<div class="bg-white h-full flex flex-col">

  <!-- Top Section (Logo + Menu + Status Banner) -->
  <div class="flex-1 overflow-auto">

    <!-- Logo -->
    <div class="px-2 border-b border-gray-300 overflow-hidden">
      <img
        [src]="logoUrl"
        [ngClass]="{
          'max-w-[200px]': !isSidebarCollapse,
          'max-w-[80px]': isSidebarCollapse
        }"
        class="p-3 pt-5 mx-auto h-auto max-h-[150px] object-fill"
        alt="Logo"
      />
    </div>

    <!-- Menu Items -->
    @for (item of menuItems; track $index) {
      @if (!item.children?.length) {
        <a
          [routerLink]="[item.route]"
          routerLinkActive="active"
          class="flex items-center p-4 text-gray-500 no-underline transition-all duration-300 hover:bg-primary-100"
          [ngClass]="{
            'hover:bg-primary-200 bg-primary-200 font-semibold': isActive(item.route),
            'justify-center': isSidebarCollapse
          }"
        >
          <div class="relative flex items-center justify-center w-6 h-6 group">
            <img class="w-5 h-5" [src]="item.icon" alt="icon" />
            @if (isSidebarCollapse) {
              <div
                class="absolute left-full ml-2 bg-white text-gray-800 text-sm rounded-lg px-3 py-1 shadow-lg whitespace-nowrap hidden group-hover:block z-10"
              >
                {{ item.title }}
              </div>
            }
          </div>
          <span
            class="ml-2 text-sm font-medium transition-all duration-300"
            [ngClass]="{ hidden: isSidebarCollapse }"
          >
            {{ item.title }}
          </span>
        </a>
      } @else {
        <!-- Expandable Group -->
        <div
          class="flex items-center justify-between px-4 py-2 cursor-pointer"
          (click)="isSitesCollapsed = !isSitesCollapsed"
        >
          <span class="text-sm font-bold text-gray-500">{{ item.title }}</span>
          @if (isSitesCollapsed) {
            <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24" stroke-width="1.5" stroke="black">
              <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5"/>
            </svg>
          } @else {
            <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none"
                 viewBox="0 0 24 24" stroke-width="1.5" stroke="black">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5"/>
            </svg>
          }
        </div>

        <!-- Submenu -->
        <div [ngClass]="{ hidden: isSitesCollapsed }">
          @for (subItem of item.children; track $index) {
            <a
              [routerLink]="[subItem.route]"
              routerLinkActive="active"
              class="flex items-center p-4 text-gray-500 no-underline transition-all duration-300 hover:bg-primary-100"
              [ngClass]="{
                'hover:bg-primary-200 bg-primary-200 font-semibold': isActive(subItem.route),
                'justify-center': isSidebarCollapse
              }"
            >
              <div class="relative flex items-center justify-center w-6 h-6 group">
                <img class="w-5 h-5" [src]="subItem.icon" alt="icon" />
                @if (isSidebarCollapse) {
                  <div
                    class="absolute left-full ml-2 bg-white text-gray-800 text-sm rounded-lg px-3 py-1 shadow-lg whitespace-nowrap hidden group-hover:block z-10"
                  >
                    {{ subItem.title }}
                  </div>
                }
              </div>
              <span
                class="ml-2 text-sm font-medium transition-all duration-300"
                [ngClass]="{ hidden: isSidebarCollapse }"
              >
                {{ subItem.title }}
              </span>
            </a>
          }
        </div>
      }
    }

    @if (customersStatusOptions === 'UNVERIFIED') {
      <div class="p-2">
        <div
          class="flex items-start gap-2 p-3 border-l-4 border-orange-500 bg-orange-50 rounded-md text-orange-700"
        ><div class="shrink-0 w-5 h-5 flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 34 30"
              fill="none"
              class="w-full h-full"
            >
              <path
                d="M17 30.25C9.17594 30.25 2.83331 24.0938 2.83331 16.5C2.83331 8.90608 9.17594 2.75 17 2.75C24.8239 2.75 31.1666 8.90608 31.1666 16.5C31.158 24.0904 24.8204 30.2416 17 30.25ZM15.5833 20.625V23.375H18.4166V20.625H15.5833ZM15.5833 9.625V17.875H18.4166V9.625H15.5833Z"
                fill="#EE6400"
              />
            </svg>
          </div>
          @if (!isSidebarCollapse) {
            <div class="text-sm leading-4 font-normal">
              Your profile is currently under review. Once verified, you will gain full access to all the features in the portal.
            </div>
          }
        </div>
      </div>
    }
  </div>

  <!-- Bottom Toggle Button (always fixed to bottom) -->
  <div class="px-2">
    <div class="flex justify-end p-3 border-t border-gray-300">
      <img
        (click)="toggleSidebar()"
        class="cursor-pointer transition-transform duration-300"
        [src]="isSidebarCollapse ? 'assets/icons/open.svg' : 'assets/icons/close.svg'"
        alt="toggle-icon"
      />
    </div>
  </div>
</div>
